import { render, staticRenderFns } from "./PackageFormsPanel.vue?vue&type=template&id=6f249b16"
import script from "./PackageFormsPanel.vue?vue&type=script&lang=js"
export * from "./PackageFormsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports